"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInitAction = exports.Version = exports.AppMessageTypes = void 0;
const utils_1 = require("../utils");
var AppMessageTypes;
(function (AppMessageTypes) {
    AppMessageTypes["Init"] = "Init";
    AppMessageTypes["SignTransaction"] = "SignTransaction";
    AppMessageTypes["SignAllTransactions"] = "SignAllTransactions";
    AppMessageTypes["SignMessage"] = "SignMessage";
})(AppMessageTypes = exports.AppMessageTypes || (exports.AppMessageTypes = {}));
var Version;
(function (Version) {
    Version["V1"] = "V1";
})(Version = exports.Version || (exports.Version = {}));
const createInitAction = ({ additionalInfo, application, description, network, icon }) => {
    const id = (0, utils_1.getRandomId)();
    return {
        type: AppMessageTypes.Init,
        application: application,
        description: description,
        additionalInfo: additionalInfo,
        network: network,
        icon,
        version: Version.V1,
        id: id
    };
};
exports.createInitAction = createInitAction;
